// extracted by mini-css-extract-plugin
module.exports = {"modalTermos":"style_modalTermos__1b2HD","ant-modal-content":"style_ant-modal-content__1kli3"};